import { COLORS } from '@cuemath/comps';
import React from 'react';
import { TextArea } from 'semantic-ui-react';
import styled from 'styled-components';

const CustomeTextArea = styled(TextArea)`
  border-color: ${COLORS.GHOST};
  width: 100%;
  border-radius: 8px;
  padding: 8px;
  &:focus {
    outline: none;
  }
`;

export default function CueTextArea({ row, onChange, placeholder }) {
  return (
    <CustomeTextArea
      placeholder=""
      onChange={(_e, { value }) => onChange(value)}
      row={row}
    />
  );
}
